import * as React from "react";
import { cn } from "@app/lib/utils";

export const emptyStateSizeClassName = {
  page: "min-h-[calc(100vh-12rem)] px-6 py-14",
  section: "min-h-[320px] px-5 py-12",
  compact: "min-h-[140px] px-4 py-8",
};

export interface EmptyStatePrimitiveProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: keyof typeof emptyStateSizeClassName;
}

export const EmptyStatePrimitive = React.forwardRef<
  HTMLDivElement,
  EmptyStatePrimitiveProps
>(({ className, size = "page", ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "flex w-full flex-1 flex-col items-center justify-center text-center",
      emptyStateSizeClassName[size],
      className,
    )}
    {...props}
  />
));

EmptyStatePrimitive.displayName = "EmptyStatePrimitive";
